module.exports = __webpack_public_path__ + "img/interchange.8d7d406e.svg";